import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Lock, User } from "react-feather";
import man from "../../../assets/images/blank_profile.png";

import { LI, UL, P } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";
import PrivilegeContext from "../../../_helper/PrivilegeContext";
import { useClinicAdmin } from "../../../_helper/ClinicProvider";
// import { useSocket } from "../../../_helper/SocketProvider";
import { useLoader } from './../../../_helper/LoaderContext';
import axiosInstance from "../../../interceptor/intercetptor-inctence";
import { usePharmacy } from "../../../_helper/PharmacyProvider";
import S3ImageLoader from "../../../S3ImageLoader";

const UserHeader = () => {
  const history = useNavigate();
  const [name, setName] = useState("Pharmacy POS");
  const { t } = useTranslation()
  const { setLoading } = useLoader();
  const imageBaseURL = process.env.REACT_APP_BASE_URL_NAKBHO;
  const { setUserPrivileges } = useContext(PrivilegeContext);
  const { clinicAdmin, setClinicAdmin } = useClinicAdmin();
  const { pharmacyPOS, setPharmacyPOS } = usePharmacy();
  // const socket = useSocket();


  const logoutUserOld = async () => {
		try {
			setLoading(true);
      const response = await axiosInstance.get(`clinic_admin/logout/${clinicAdmin._id}`);
			if (response.data.status === "success") {
				// Logout();
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoading(false);
		}
	};

  const logoutUser = () => {
    setUserPrivileges(null);
    localStorage.removeItem("profileURL");
    localStorage.removeItem("pharmacyPOSAuth");
    localStorage.removeItem("currentPharmacyPOS");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    // socket.emit('userLogout', { userId: clinicAdmin._id, userRole: clinicAdmin.role })
		// socket.disconnect();
    // setClinicAdmin(null);
    setPharmacyPOS(null);
    history(`${process.env.PUBLIC_URL}/login`, { replace: true });
  };

  const changePassword = () => {
    history(`${process.env.PUBLIC_URL}/change-password`);
  };
  const updateProfile = () => {
    history(`${process.env.PUBLIC_URL}/update-profile`);
    // history(`${process.env.PUBLIC_URL}/profile`);
  };

  return (
    <li className="py-0 profile-nav onhover-dropdown pe-0">
      <div className="media profile-media" style={{ alignItems: 'center'}}>
        <S3ImageLoader
          className="m-0 b-r-10"
          fileName={pharmacyPOS?.logo}
          style={{ height: '32px', width: '32px', objectFit: 'cover' }}
          alt="profile"
          fallbackSrc={man}
        />
        {/* src: `${authenticated ? clinicAdmin?.picture : profile}`, */}
        <div className="media-body">
          {/* <span>{authenticated ? clinicAdmin?.name : name}</span> */}
          <span>{pharmacyPOS?.facility_name || name}</span>
          {/* <P attrPara={{ className: "mb-0 font-roboto" }}>
            {clinicAdmin?.role === 'clinic_admin' ? (
              <span>{t("Clinic Admin")}</span>
            ) : clinicAdmin?.role === "sub admin" ? (
              "Sub Admin"
            ) : clinicAdmin?.role === "staff" ? (
              "Staff"
            ) : clinicAdmin?.role === "accountant" ? (
              "Accountant"
            ) : (
              "Sub Admin"
            )}
          </P> */}
        </div>
      </div>
      <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
        {/* <LI attrLI={{ onClick: updateProfile }}>
          <User />
          <span>{t("profile")}</span>
        </LI>
        <LI attrLI={{ onClick: changePassword }}>
          <Lock />
          <span>{t("changePassword")}</span>
        </LI> */}
        <LI attrLI={{ onClick: logoutUser }}>
          <LogIn />
          <span>{t("logOut")}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
